import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-83aee872"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container mb-4" }
const _hoisted_2 = { class: "container-fluid" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-md-6 col-lg-4 order-first order-md-last d-flex align-items-center" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex-grow-1" }, null, -1))
const _hoisted_6 = { class: "logo" }
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "col" }
const _hoisted_9 = { class: "row" }
const _hoisted_10 = { class: "col" }
const _hoisted_11 = {
  class: "mt-4",
  style: {"white-space":"pre-wrap"}
}
const _hoisted_12 = { class: "col-md-4 col-lg-3" }

import providePersonFormInfo from "@/types/symbols/providePersonFormInfo";
import { onMounted, ref, computed, provide, watch } from "vue";
import publicFormApi from "@/publicFormApi";
import JobSeekerForm from "@/components/form/jobSeekerForm/JobSeekerForm.vue";
import FormSection from "@/components/form/FormSection.vue";
import { FormDataDto } from "@api/form-data-dto";
import { getEntityTranslation, getOrganizationNameTranslation } from "@/helpers";
import LanguageSelection from "@/components/LanguageSelection.vue";
import router from "@/router";
import { useAppStore } from "@/pinia/appStore";
import { defaultTitle } from "@/router";
import { PersonFieldCategoryDto } from "@api/person-field-category-dto";
import { BusinessIdeaFieldCategoryDto } from "@api/business-idea-field-category-dto";
import provideBusinessIdeaFieldCategoriesInfo from "@/types/symbols/provideBusinessIdeaFieldCategoriesInfo";
import { logoUrl } from "@/composables/logoUrl";


export default /*#__PURE__*/_defineComponent({
  __name: 'JobSeekerFormView',
  setup(__props) {

const orgInfo = computed(() => useAppStore().organizationInfo);
const formInfo = ref<FormDataDto<PersonFieldCategoryDto> | null>(null);
const fieldCategories = ref<PersonFieldCategoryDto[]>([]);
const businessIdeaFieldCategories = ref<BusinessIdeaFieldCategoryDto[]>([]);

provide(providePersonFormInfo, formInfo);
provide(provideBusinessIdeaFieldCategoriesInfo, businessIdeaFieldCategories);

const session = useAppStore();

const onSuccess = () => {
	session.$state.formSentSuccesfully = true;
	router.push({ name: "JobSeekerFormSuccess" });
};

const onFailed = () => {
	session.$state.formSentSuccesfully = false;
	router.push({ name: "JobSeekerFormFailed" });
};

const titleComputed = computed(() => {
	if (formInfo.value) {
		const t = getEntityTranslation(formInfo.value.publicForm.translations, "name");
		if (t) {
			return t;
		}
	}
	return null;
});

watch(titleComputed, (newTitle) => {
	if (newTitle) {
		window.document.title = newTitle;
		return;
	}
	window.document.title = defaultTitle;
});

onMounted(() => {
	session.$state.formSentSuccesfully = false;

	publicFormApi.call.personForm.get.fields("jobSeekerForm").then((resp) => {
		if (resp.isSuccessful && resp.data) {
			fieldCategories.value = resp.data;
		}
	});

	publicFormApi.call.personForm.get.getFormInfo("jobSeekerForm").then((resp) => {
		if (resp.isSuccessful && resp.data) {
			formInfo.value = resp.data;
		}
	});
});

const updateUrl = (lang: string, org: string) => {
	router.replace({
		name: "JobSeekerForm",
		params: {
			org: org,
			lang: lang,
		},
	});
};

return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    (formInfo.value)
      ? (_openBlock(), _createBlock(FormSection, { key: 0 }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _hoisted_5,
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("img", { src: _unref(logoUrl) }, null, 8, _hoisted_7)
                  ])
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("h1", null, _toDisplayString(_unref(getEntityTranslation)(formInfo.value.publicForm.translations, "name")), 1),
                  _createElementVNode("h5", null, _toDisplayString(_unref(getOrganizationNameTranslation)(formInfo.value)), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("p", _hoisted_11, _toDisplayString(_unref(getEntityTranslation)(formInfo.value.publicForm.translations, "publicDescription")), 1)
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _createVNode(LanguageSelection, {
                    languages: formInfo.value.publicForm.languages,
                    onLangChanged: updateUrl
                  }, null, 8, ["languages"])
                ])
              ])
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (formInfo.value)
      ? (_openBlock(), _createBlock(JobSeekerForm, {
          key: 1,
          onSaveSuccess: onSuccess,
          onSaveFailed: onFailed
        }))
      : _createCommentVNode("", true)
  ], 512)), [
    [_vShow, orgInfo.value]
  ])
}
}

})